require('./bootstrap')
require('./confirmation')
require('./forms')
require('./tooltips')
require('./popovers')
